import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Button,
  DialogTitle,
  Divider,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Dialog,
  DialogActions,
  Typography
} from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import apiConfigs from "../../config/config";
import { updateCategory } from "../../store/action";
import Notification from "../../components/Notification/Notification";

const useStyle = makeStyles((theme) => ({
  dialogWidth: { width: "100%", background: theme.palette.background.main },
  radioGroup: {
    flexDirection: "row",
  },
}));

function UpdateCategory({ open, handleClose, id }) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [categoryNotify, setCategoryNotify] = useState(false);
  const { speUpdateSuccess, speUpdateErrors } = useSelector(
    (state) => state.candidateCategory
  );
  const [data, setData] = useState({
    category_name: "",
    category_description: "",
    status: ""
  })

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const specialityUpdate = (event) => {
    event.preventDefault();
    dispatch(updateCategory(data));
    setCategoryNotify(true);
  };

  useEffect(() => {
    if (speUpdateSuccess?.message) {
      handleClose();
    }
  }, [speUpdateSuccess]);

  const getData = async (id) => {
    if (id > 0) {
      const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
      axios
        .get(`${apiConfigs.API_URL}api/organization/fetchCategoryById/${id}`, {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        })
        .then((response) => {
          setData(response.data.data);
        })
        .catch((error) => {
          console.error("error.message", error.message);
        });
    }
  };

  useEffect(() => {
    setData("");
    getData(id);
  }, [id]);

  const handleClose1 = () => {
    handleClose();
    // reset();
  };
  const statusList = [
    {
      id: "active",
      status_name: 'Active',
    },
    {
      id: "deactive",
      status_name: 'Inactive',
    }
  ];
  return (
    <>
      {categoryNotify && speUpdateSuccess?.message && (
        <Notification data={speUpdateSuccess?.message} status="success" />
      )}
      <Dialog
        open={open}
        onClose={handleClose1}
        classes={{ paper: classes.dialogWidth }}
      >
        <form>
          <DialogTitle id="form-dialog-title">
            <Typography variant="h6"
            >Update Category</Typography>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
              <TextField
                autoFocus
                margin="dense"
                id="CategoryName"
                label="Category Name"
                variant="outlined"
                name="category_name"
                fullWidth
                required
                value={data?.category_name || ""}
                onChange={handleChange}
                error={speUpdateErrors?.message ? true : false}
                helperText={
                  speUpdateErrors?.message ? speUpdateErrors?.message : ""
                }
              />

              <TextField
                margin="dense"
                id="CategoryDescription"
                label="Category Description"
                variant="outlined"
                name="category_description"
                fullWidth
                required
                multiline
                minRows={3}
                value={data?.category_description || ""}
                onChange={handleChange}
                sx={{ mt: 2 }}
              />

              <FormControl
                variant="outlined"
                fullWidth
                sx={{ mt: 4 }}
              >
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status"
                  name="status"
                  value={data?.status || ""}
                  label="Status"
                  onChange={handleChange}
                >
                  <MenuItem value="">Select Status</MenuItem>
                  {statusList &&
                    statusList.map((items) => (
                      <MenuItem value={items.id} key={items.id}>
                        {items.status_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions className="pr-4 pb-2">
            <Button onClick={handleClose1} color="primary">Cancel</Button>
            <Button
              color="secondary"
              type="submit"
              variant="contained"
              onClick={(event) => specialityUpdate(event)}
              formNoValidate
            >
              Update
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default UpdateCategory;
